/* apps/viewer/src/app/settings/settings.component.scss */
.ori-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0);
}
.ori-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1);
}
.ori-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2);
}
.ori-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3);
}
.ori-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4);
}
.ori-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5);
}
.ori-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6);
}
.ori-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7);
}
.ori-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8);
}
.ori-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9);
}
.ori-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10);
}
.ori-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11);
}
.ori-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12);
}
.ori-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13);
}
.ori-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14);
}
.ori-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15);
}
.ori-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16);
}
.ori-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17);
}
.ori-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18);
}
.ori-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19);
}
.ori-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20);
}
.ori-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21);
}
.ori-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22);
}
.ori-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23);
}
.ori-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24);
}
.header {
  align-items: center;
  border-bottom: 1px solid #cecece;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  height: 60px;
}
.header .logo-items {
  align-items: center;
  max-height: 30px;
}
.header .logo-items .icon {
  margin: 0 5px;
}
.header .icon {
  background-color: transparent;
  cursor: pointer;
  height: 30px;
  transition: all ease 0.3s;
  width: 30px;
}
.header .icon ::ng-deep svg {
  height: 30px;
  transition: all ease 0.3s;
  width: 30px;
}
.not-clickable {
  cursor: default;
  pointer-events: none;
}
mat-list {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0;
}
mat-list .mat-list-item-disabled {
  background: transparent;
}
mat-list .mat-list-item-disabled .mat-icon {
  color: #aaa !important;
}
mat-list .mat-list-item-disabled .text-icon {
  background-color: #aaa !important;
}
.matlist--top .mat-icon {
  margin-right: 10px;
  vertical-align: bottom;
}
.item-clickable {
  cursor: pointer !important;
  transition: all ease 0.3s;
}
.item-clickable:active,
.item-clickable:hover {
  transition: all ease 0.3s;
}
.item-clickable:focus {
  outline: none;
}
.item-clickable a {
  outline: none;
  text-decoration: none;
}
.mat-badge span {
  font-size: 10px !important;
}
.login-container {
  color: #fafafa;
  display: grid;
  font-size: 13px;
  font-weight: 400;
  grid-template-columns: 50px 1fr 40px 40px;
  height: 60px;
}
.logo-user {
  display: grid;
  place-self: center;
}
.login-informations {
  align-self: center;
  display: grid;
  grid-template-columns: 1fr;
}
.login-name {
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.login-link {
  align-content: center;
  align-items: stretch;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin: auto;
}
.login-link .log-icon {
  margin: auto 5px;
  width: 25px;
}
.cross-logo {
  align-self: center;
  min-width: 40px;
}
.offline-logo {
  margin: auto;
  width: 20px;
}
.logout {
  height: 40px;
  width: 40px;
}
.login-logo {
  background-color: #666;
  border: none;
  border-radius: 50%;
  color: white;
  display: inline-block;
  font-size: 18px;
  padding: 9px;
  text-align: center;
  text-decoration: none;
  width: 36px;
}
.mail {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.icon-offline,
.icon-close {
  max-width: unset;
  width: 100%;
}
.icon-offline:hover,
.icon-offline:focus,
.icon-close:hover,
.icon-close:focus {
  transition: all ease 0.3s;
}
.icon-offline:hover ::ng-deep svg,
.icon-offline:focus ::ng-deep svg,
.icon-close:hover ::ng-deep svg,
.icon-close:focus ::ng-deep svg {
  fill: #fafafa;
  transition: all ease 0.3s;
}
.user-auth {
  align-items: center;
  bottom: 0;
  color: #fafafa;
  display: grid;
  grid-template-columns: auto 1fr;
  height: 40px;
  margin-top: 20px;
  width: 100%;
}
.user-auth .mat-button {
  padding-right: 0;
}
.hide {
  cursor: default;
  visibility: hidden;
}
.mat-button {
  height: 100%;
}
.header-login {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}
/*# sourceMappingURL=settings.component.css.map */
